<template>
    <router-link class="header__cart" aria-label="Корзина с товарами"
    :to="{name: 'cart'}">
        <svg width="30" height="21" fill="currentColor">
          <use xlink:href="#icon-cart"></use>
        </svg>
        <span v-if="$store.state.loadIndicator === true">
          <img class="pre" src="../../public/img/Spinning wheel.gif" alt="">
        </span>
        <span v-else class="header__count" aria-label="Количество товаров">
          {{ $store.state.cartProducts.length }}</span>
      </router-link>
</template>

<script>
export default {

};
</script>
